import vue from "vue";
import { initialState } from "./initialState";
export default {
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions;
    },
    SET_FORMATTED_PERMISSIONS: (state, formattedPermissions) => {
        state.formattedPermissions = formattedPermissions;
    },
    SET_PERMISSION_GROUPS: (state, permissionGroups) => {
        state.permissionGroups = permissionGroups;
    },
    SET_PERMISSION_GROUP_TITLE: (state, permissionGroupTitle) => {
        state.permissionGroupTitle = permissionGroupTitle;
    },
    SET_PERMISSION_TO_CREATE: (state, permissionToCreate) => {
        state.permissionToCreate = permissionToCreate;
    },
    SET_SELECTED_USER_PERMISSIONS: (state, selectedUserPermissions) => {
        state.selectedUserPermissions = selectedUserPermissions;
    },
    SET_SELECTED_USER_PERMISSION_GROUPS: (state, selectedUserPermissionGroups) => {
        state.selectedUserPermissionGroups = selectedUserPermissionGroups;
    },
    SET_GROUP_TO_EDIT: (state, groupToEdit) => {
        state.groupToEdit = groupToEdit;
    },
    SET_PERMISSION_TO_EDIT: (state, permissionToEdit) => {
        state.permissionToEdit = permissionToEdit;
    },
    SET_USER_PERMISSION_UNITS: (state, userPermissionUnits) => {
        state.userPermissionUnits = userPermissionUnits;
    },
    SET_PERMISSION_UNITS: (state, permissionUnits) => {
        state.permissionUnits = permissionUnits;
    },
    SET_USER_PERMISSION_ROOMS: (state, userPermissionRooms) => {
        state.userPermissionRooms = userPermissionRooms;
    },
    SET_USER_PERMISSION_REPEATER_ROOMS: (state, userPermissionRepeaterRooms) => {
        state.userPermissionRepeaterRooms = userPermissionRepeaterRooms;
    },
    SET_PERMISSION_ROOMS: (state, permissionRooms) => {
        state.permissionRooms = permissionRooms;
    },
    RESET_PERMISSION_GROUP: (state) => {
        state.permissionGroupTitle = null;
        Object.assign(state.permissionToCreate, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionToCreate))))
        state.selectedUserPermissions = []
        Object.assign(state.selectedUserPermissionGroups, JSON.parse(JSON.stringify(_.cloneDeep(initialState.selectedUserPermissionGroups))))
        // Object.assign(state.permissionGroupTitle, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionGroupTitle))))
    },
    RESET_PERMISSION: (state) => {
        Object.assign(state.permissionToCreate, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionToCreate))))
        Object.assign(state.permissions, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissions))))
        // Object.assign(state.permissionGroupTitle, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionGroupTitle))))
    },
    RESET_PERMISSION_UNITS: (state) => {
        Object.assign(state.userPermissionUnits, JSON.parse(JSON.stringify(_.cloneDeep(initialState.userPermissionUnits))))
        // Object.assign(state.permissionUnits, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionUnits))))
    },
    RESET_PERMISSION_ROOMS: (state) => {
        Object.assign(state.userPermissionRooms, JSON.parse(JSON.stringify(_.cloneDeep(initialState.userPermissionRooms))))
        // Object.assign(state.permissionRooms, JSON.parse(JSON.stringify(_.cloneDeep(initialState.permissionRooms))))
    },
   
}